import { Droplets } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary text-secondary-foreground py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-xl bg-primary flex items-center justify-center">
                <Droplets className="w-6 h-6 text-primary-foreground" />
              </div>
              <span className="font-display text-xl font-bold">GripMax</span>
            </Link>
            <p className="text-muted max-w-sm mb-6">
              Your trusted resource for all things liquid chalk. 
              Helping athletes achieve maximum grip since 2024.
            </p>
            <p className="text-xs text-muted">
              As an Amazon Associate, we earn from qualifying purchases. 
              This helps support our content at no extra cost to you.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display font-bold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="#benefits" className="text-muted hover:text-secondary-foreground transition-colors">
                  Benefits
                </a>
              </li>
              <li>
                <a href="#comparison" className="text-muted hover:text-secondary-foreground transition-colors">
                  Compare Chalks
                </a>
              </li>
              <li>
                <a href="#quiz" className="text-muted hover:text-secondary-foreground transition-colors">
                  Grip Quiz
                </a>
              </li>
              <li>
                <Link to="/blog" className="text-muted hover:text-secondary-foreground transition-colors">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-display font-bold text-lg mb-4">Resources</h4>
            <ul className="space-y-3">
              <li>
                <a href="#faq" className="text-muted hover:text-secondary-foreground transition-colors">
                  FAQ
                </a>
              </li>
              <li>
                <a
                  href="https://amzn.to/49KcFQm"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted hover:text-secondary-foreground transition-colors"
                >
                  Buy on Amazon
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-secondary-foreground/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted">
            © {currentYear} GripMax. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <a href="#" className="text-muted hover:text-secondary-foreground transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-muted hover:text-secondary-foreground transition-colors">
              Terms of Service
            </a>
            <a href="#" className="text-muted hover:text-secondary-foreground transition-colors">
              Affiliate Disclosure
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
